import FlagIcon from "@mui/icons-material/Flag";
import { IconButton, Tooltip, Zoom } from "@mui/material";

import { CarrierBlockedSource } from "constants/index";
import { useDisclosure, useRoleContext } from "hooks";

import { BlockCarrierModal } from "./BlockCarrierModal";

interface Props {
  carrierId: number;
  firstName?: string;
  lastName?: string;
  companyName: string;
}

export function BlockCarrierButton(props: Props) {
  const { carrierId, firstName, lastName, companyName } = props;
  const { role } = useRoleContext();
  const {
    isOpen: confirmationModalOpen,
    onClose: onCloseConfirmationModal,
    onOpen: onOpenConfirmationModal,
  } = useDisclosure(false);

  const showButton = role?.type === "SHIPPER";

  if (!showButton) {
    return null;
  }

  return (
    <>
      <Tooltip title="Block Carrier" placement="top" TransitionComponent={Zoom}>
        <IconButton
          onClick={onOpenConfirmationModal}
          size="small"
          sx={{
            p: 0,
            "&:hover": { backgroundColor: "transparent" },
            color: "black",
          }}
        >
          <FlagIcon fontSize="small" sx={{ color: "black" }} />
        </IconButton>
      </Tooltip>
      <BlockCarrierModal
        open={confirmationModalOpen}
        onClose={onCloseConfirmationModal}
        carrierId={carrierId}
        companyName={companyName}
        firstName={firstName}
        lastName={lastName}
        source={CarrierBlockedSource.SHIPMENT_PAGE}
      />
    </>
  );
}
